import LocationLayout from "./LocationLayout";
import {getBookableLocations} from "../../helpers/locations";

export default function LocationOpenedLayout({
                                                 location,
                                                 data,
                                                 trialSlotsResponse,
                                                 hasCookiePreferences,
                                                 cookiePreferences
                                             }) {

    return (
        <LocationLayout location={location}
                        data={data}
                        hasVideo={!!data.headerVideo}
                        showIntro={true}
                        showFullscreen={true}
                        showConcepts={true}
                        showTrainers={true}
                        showMap={true}
                        showScheduleTrial={getBookableLocations().includes(location)}
                        showFeatures={false}
                        hasCookiePreferences={hasCookiePreferences}
                        cookiePreferences={cookiePreferences}
                        trialSlotsResponse={trialSlotsResponse}
        />
    )
}